// import { DirectiveFunction } from 'vue'

// const touchCalss: DirectiveFunction = (el, binding) => {
//   if (!binding.value) return

//   el.addEventListener('touchstart', () => {
//     el.classList.add(binding.value)
//   })
//   el.addEventListener('touchend', () => {
//     el.classList.remove(binding.value)
//   })
// }

import { DirectiveOptions } from 'vue'

const touchCalss: DirectiveOptions = {
  bind(el, binding) {
    if (!binding.value) return
    const elAny = el as any
    elAny.touchstartHandler = () => {
      el.classList.add(binding.value)
    }
    elAny.touchendHandler = () => {
      el.classList.remove(binding.value)
    }
    el.addEventListener('touchstart', elAny.touchstartHandler, false)
    el.addEventListener('touchend', elAny.touchendHandler, false)
  },
  unbind(el) {
    const elAny = el as any
    if (!elAny.touchstartHandler) return

    el.removeEventListener('touchstart', elAny.touchstartHandler)
    el.removeEventListener('touchend', elAny.touchendHandler)
    elAny.touchstartHandler = null
    elAny.touchendHandler = null
  }
}

export default touchCalss
